import { render, staticRenderFns } from "./resourceConfig.vue?vue&type=template&id=3cd5ccfa&scoped=true"
import script from "./resourceConfig.vue?vue&type=script&lang=js"
export * from "./resourceConfig.vue?vue&type=script&lang=js"
import style0 from "./resourceConfig.vue?vue&type=style&index=0&id=3cd5ccfa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5ccfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd5ccfa')) {
      api.createRecord('3cd5ccfa', component.options)
    } else {
      api.reload('3cd5ccfa', component.options)
    }
    module.hot.accept("./resourceConfig.vue?vue&type=template&id=3cd5ccfa&scoped=true", function () {
      api.rerender('3cd5ccfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/resourceConfig.vue"
export default component.exports